var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[_c('Banner'),_c('Lead'),_c('Present'),_c('Partner'),_c('Contact')],1)}
var staticRenderFns = []

export { render, staticRenderFns }